// extracted by mini-css-extract-plugin
export default {"pageWrap":"dd-z","fullWidth":"ed-z","heading":"fd-z","fullBleed":"gd-z","hidden":"hd-z"};